import { FaMapSigns } from "react-icons/fa";
import { MdComputer } from "react-icons/md";
import { MdSecurity } from "react-icons/md";
import { FaLayerGroup } from "react-icons/fa";

const data = [
  {
    img: <FaLayerGroup />,
    title: "Transparency",
    description: "Cryptography, encryption process referred to as plaintext",
  },
  {
    img: <FaMapSigns />,
    title: "External Method",
    description: "Cryptography, encryption process referred to as plaintext",
  },
  {
    img: <MdComputer />,
    title: "User Dashboard",
    description: "Cryptography, encryption process referred to as plaintext",
  },
  {
    img: <MdSecurity />,
    title: "High Security",
    description: "Cryptography, encryption process referred to as plaintext",
  },
];

export default data;
